package com.daytimegaming.ourdailyfinances.data.network.service

import com.daytimegaming.ourdailyfinances.data.network.ApiClient
import com.daytimegaming.ourdailyfinances.data.network.dto.ServerEventDto
import com.daytimegaming.ourdailyfinances.domain.repository.AuthRepository
import io.ktor.client.request.get
import io.ktor.client.statement.bodyAsChannel
import io.ktor.utils.io.readLine
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import kotlinx.serialization.json.Json

class EventStreamService(
    private val apiClient: ApiClient,
    private val authRepository: AuthRepository
) {
    private val json = Json { ignoreUnknownKeys = true }

    fun getEventsStream(): Flow<ServerEventDto> = flow {
        val token = try {
            authRepository.getIdToken()
        } catch (e: Exception) {
            ""
        }
        if (token.isEmpty()) return@flow

        val url = "${apiClient.baseUrl}/events/stream?token=$token"
        try {
            val response = apiClient.http.get(url)
            val channel = response.bodyAsChannel()

            while (!channel.isClosedForRead) {
                val line = channel.readLine() ?: break
                if (line.startsWith("data: ")) {
                    val jsonText = line.removePrefix("data: ").trim()
                    try {
                        val eventDto = json.decodeFromString<ServerEventDto>(jsonText)
                        emit(eventDto)
                    } catch (e: Exception) {
                        // Ignore parse errors or keep-alive comments
                    }
                }
            }
        } catch (e: Exception) {
            // Connection closed or interrupted
        }
    }
}
